@import '../../../common/result-list/styles/placeholders.pcss';
@import '../../../common/result-list/styles/table-display.pcss';
@import '../../../common/result-list/styles/list-display.pcss';
@import '../../../common/result-list/styles/grid-display.pcss';
